import { PRDService } from '@/services'

const getDefaultState = () => {
    return {
        product: {},
        components: [],
        newComponent: null,
        error: null,
        fetching: false,
    }
}

const state = getDefaultState()

const actions = {
    resetState({ commit }) {
        commit('resetState')
    },

    fetchOrCreateProduct({ dispatch, commit }, { product_name, product_brand }) {
        if (product_name === "" || product_brand === "") return

        commit('setFetching', true)
        commit('resetState')

        PRDService.fetchOrCreateProduct(product_name, product_brand)
        .then(({ status, data }) => {
            // if (status === 201) {
                commit('setProduct', data)
                dispatch('fetchProductComponents')
            // }
        })
        .finally(() => commit('setFetching', false))
    },
    updateProduct({ commit, state }) {
      if (!state.product.id) return

      commit('setFetching', true)

      const { id, m_b, index_code, useful_life_months, product_type } = state.product
      return PRDService.updateProduct(id, {m_b, index_code, useful_life_months, product_type})
      .then(({ status, data }) => {
          if (status === 200) {
              commit('resetState')
          }
      })
    },
    deleteProduct({ dispatch, commit }, id) {
      if (id === 0) return

      commit('setFetching', true)

      PRDService.deleteProduct(id)
      .then(({ status, data }) => {
          if (status === 200) {
            commit('resetState')
          }
      })
      .finally(() => commit('setFetching', false))
  },
    fetchProductComponents({ state, commit }) {
        PRDService.fetchProductComponents(state.product.product_name, state.product.product_brand)
        .then(({ status, data }) => {
            if (status === 200) {
                commit('setComponents', data)
            }
        })
    },
    createComponent({ state, commit }, product_code ) {
        return PRDService.createProductComponent({ id: state.product.id, product_code })
        .then(({ status, data }) => {
            if (status === 201) {
                commit('addComponent', data)
                commit('clearNewComponent')
            }
        })
    },
    updateComponent({ commit }, { id, uofme_code} ) {
      PRDService.updateProductComponent( id, { uofme_code })
      .then(({ status, data }) => {
          if (status === 200) {
              commit('updateComponent', data)
          }
      })
  },
    deleteComponent({ commit }, id) {
        PRDService.deleteProductComponent(id)
        .then(({ status, data }) => {
            if (status === 200) {
                commit('removeComponent', data.id)
            }
        })
    },
}

const mutations = {
    resetState: (state) => (Object.assign(state, getDefaultState())),
    clearNewComponent: (state) => (state.newComponent = null),
    setFetching: (state, payload) => (state.fetching = payload),
    setProduct: (state, product) => (state.product = product),
    setComponents: (state, components) => (state.components = components),
    addComponent: (state, item) => (state.components.push(item)),
    updateComponent: (state, item) => {
        let index = state.detail.findIndex(el => el.id === item.id);
        if (index>=0) {
            state.components[index].uofme_code = item.uofme_code
        }
    },
    // createNewComponen: (state, payload) => {
    //     state.newComponent = {
    //         product_base: state.order.product_base,
    //         quantity: 0,
    //         unitsPerMachine: 0,
    //         machineQty: 0,
    //         ...payload
    //     }
    // },
    // addAssembly: (state, payload) => {
    //     state.assembly.push(...payload)
    // },
    // updateAssembly: (state, payload) => {
    //     let index = state.assembly.findIndex(el => el.id === payload.id);
    //     if (index>=0) {
    //         state.assembly[index].qty_used = payload.qty_used
    //         state.assembly[index].qty_rejected = payload.qty_rejected
    //     }
    // },
    removeComponent: (state, id) => (state.components = state.components.filter(el => el.id !== id)),
    // removeAssembly: (state, seq_number) => (state.assembly = state.assembly.filter(el => el.seq_number !== seq_number)),
    // setErrorAnalysis: (state, errorAnalysis) =>
    // (state.errorAnalysis = errorAnalysis),
    // setPosting: (state, payload) => (state.posting = payload)
    set: (state, {key, value}) => {
      if (!state.product) return
      state.product[key] = value
  },
}


export const prdProduct = {
    namespaced: true,
    state,
    mutations,
    actions,
}



// WEBPACK FOOTER //
// ./src/store/prd.product.module.js